import React from 'react';

export default function CustomVideoPlayer({ src }) {
  return (
    <div className="rounded-xl overflow-hidden shadow-2xl border border-white/10 bg-black my-2 relative group">
      <video
        src={src}
        controls
        playsInline
        className="w-full max-h-[350px] object-contain rounded-xl"
      />
    </div>
  );
}